import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { FaBars, FaChevronDown } from 'react-icons/fa';
import { IconContext } from 'react-icons/lib';
import { animateScroll as scroll } from 'react-scroll';
import {
  Nav,
  NavbarContainer,
  NavLogo,
  MobileIcon,
  NavMenu,
  NavItem,
  NavItemWithDropdown,
  NavLinks,
  NavBtn,
  NavBtnLink,
  NavLinkToPage,
  ServicesTrigger,
  DropdownMenu,
  DropdownItem
} from './NavbarElements';
import logo from '../../images/New_logo.png';

const Navbar = ({ toggle }) => {
  const location = useLocation();
  const isHome = location.pathname === '/';

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const [scrollNav, setScrollNav] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);

  const changeNav = () => {
    setScrollNav(window.scrollY >= 80);
  };

  useEffect(() => {
    window.addEventListener('scroll', changeNav);
    return () => window.removeEventListener('scroll', changeNav);
  }, []);

  const toggleHome = () => {
    scroll.scrollToTop();
  };

  const handleNavToSection = (sectionId) => () => {
    if (isHome) {
      scrollToSection(sectionId);
    }
  };

  /** When not on home, link to / with state so Home can scroll to section after mount */
  const homeLinkWithScroll = (sectionId) => ({ pathname: '/', state: { scrollTo: sectionId } });

  return (
    <IconContext.Provider value={{ color: '#fff' }}>
      <Nav scrollNav={scrollNav}>
        <NavbarContainer>
          <NavLogo to="/" onClick={toggleHome}>
            <img src={logo} alt="Wiry" style={{ height: '48px', width: 'auto' }} />
          </NavLogo>
          <MobileIcon onClick={toggle} aria-label="Menu">
            <FaBars />
          </MobileIcon>
          <NavMenu>
            <NavItem>
              {isHome ? (
                <NavLinks to="about" smooth duration={500} spy offset={-80}>
                  About
                </NavLinks>
              ) : (
                <NavLinkToPage to={homeLinkWithScroll('about')}>
                  About
                </NavLinkToPage>
              )}
            </NavItem>
            <NavItem>
              {isHome ? (
                <NavLinks to="expertise" smooth duration={500} spy offset={-80}>
                  Expertise
                </NavLinks>
              ) : (
                <NavLinkToPage to={homeLinkWithScroll('expertise')}>
                  Expertise
                </NavLinkToPage>
              )}
            </NavItem>
            <NavItemWithDropdown
              onMouseEnter={() => setServicesOpen(true)}
              onMouseLeave={() => setServicesOpen(false)}
            >
              <ServicesTrigger>
                Services <FaChevronDown style={{ marginLeft: '4px', fontSize: '0.75rem' }} />
              </ServicesTrigger>
              <DropdownMenu isOpen={servicesOpen}>
                <DropdownItem to="/service/seo" onClick={() => setServicesOpen(false)}>
                  SEO
                </DropdownItem>
                <DropdownItem to="/service/social-media" onClick={() => setServicesOpen(false)}>
                  Social Media
                </DropdownItem>
                <DropdownItem to="/service/digital" onClick={() => setServicesOpen(false)}>
                  Digital & Virtual Tours
                </DropdownItem>
              </DropdownMenu>
            </NavItemWithDropdown>
            <NavItem>
              <NavLinkToPage to="/meet-the-team">
                Meet the Team
              </NavLinkToPage>
            </NavItem>
            <NavItem>
              {isHome ? (
                <NavLinks to="contactus" smooth duration={500} spy offset={-80}>
                  Careers
                </NavLinks>
              ) : (
                <NavLinkToPage to={homeLinkWithScroll('contactus')}>
                  Careers
                </NavLinkToPage>
              )}
            </NavItem>
          </NavMenu>
          <NavBtn>
            <NavBtnLink to="/getquote">Get Quote</NavBtnLink>
          </NavBtn>
        </NavbarContainer>
      </Nav>
    </IconContext.Provider>
  );
};

export default Navbar;
